export const root = "r9qq52j";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");